/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable,
    JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicableFromJSON,
    JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicableFromJSONTyped,
    JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicableToJSON,
} from './JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable';
import {
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableDataFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableDataFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableDataToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData';
import {
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetailsFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetailsFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetailsToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails';
import {
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList';
import {
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse {
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData>}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    availableDataList?: Array<JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableData>;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    scrennDisplayItemList?: JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    useDate?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    nightCntTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    subTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    subsidyAmountTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    billingAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    doneApplyCafe?: boolean;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    cafeUsePoint?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    benepoUseFlag?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    benepoAmountTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    headCntTotal?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    chldSubTotalPp?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    adultsSubTotalPp?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    memberAdults?: number;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    memberChldDetails?: JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails;
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable>}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    couponApplicable?: Array<JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable>;
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation>}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse
     */
    subsidyReservations?: Array<JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation>;
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'availableDataList': !exists(json, 'availableDataList') ? undefined : ((json['availableDataList'] as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableDataFromJSON)),
        'scrennDisplayItemList': !exists(json, 'scrennDisplayItemList') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListFromJSON(json['scrennDisplayItemList']),
        'useDate': !exists(json, 'useDate') ? undefined : json['useDate'],
        'nightCntTotal': !exists(json, 'nightCntTotal') ? undefined : json['nightCntTotal'],
        'subTotal': !exists(json, 'subTotal') ? undefined : json['subTotal'],
        'subsidyAmountTotal': !exists(json, 'subsidyAmountTotal') ? undefined : json['subsidyAmountTotal'],
        'billingAmount': !exists(json, 'billingAmount') ? undefined : json['billingAmount'],
        'doneApplyCafe': !exists(json, 'doneApplyCafe') ? undefined : json['doneApplyCafe'],
        'cafeUsePoint': !exists(json, 'cafeUsePoint') ? undefined : json['cafeUsePoint'],
        'benepoUseFlag': !exists(json, 'benepoUseFlag') ? undefined : json['benepoUseFlag'],
        'benepoAmountTotal': !exists(json, 'benepoAmountTotal') ? undefined : json['benepoAmountTotal'],
        'headCntTotal': !exists(json, 'headCntTotal') ? undefined : json['headCntTotal'],
        'chldSubTotalPp': !exists(json, 'chldSubTotalPp') ? undefined : json['chldSubTotalPp'],
        'adultsSubTotalPp': !exists(json, 'adultsSubTotalPp') ? undefined : json['adultsSubTotalPp'],
        'memberAdults': !exists(json, 'memberAdults') ? undefined : json['memberAdults'],
        'memberChldDetails': !exists(json, 'memberChldDetails') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetailsFromJSON(json['memberChldDetails']),
        'couponApplicable': !exists(json, 'couponApplicable') ? undefined : ((json['couponApplicable'] as Array<any>).map(JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicableFromJSON)),
        'subsidyReservations': !exists(json, 'subsidyReservations') ? undefined : ((json['subsidyReservations'] as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationFromJSON)),
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'availableDataList': value.availableDataList === undefined ? undefined : ((value.availableDataList as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseAvailableDataToJSON)),
        'scrennDisplayItemList': JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListToJSON(value.scrennDisplayItemList),
        'useDate': value.useDate,
        'nightCntTotal': value.nightCntTotal,
        'subTotal': value.subTotal,
        'subsidyAmountTotal': value.subsidyAmountTotal,
        'billingAmount': value.billingAmount,
        'doneApplyCafe': value.doneApplyCafe,
        'cafeUsePoint': value.cafeUsePoint,
        'benepoUseFlag': value.benepoUseFlag,
        'benepoAmountTotal': value.benepoAmountTotal,
        'headCntTotal': value.headCntTotal,
        'chldSubTotalPp': value.chldSubTotalPp,
        'adultsSubTotalPp': value.adultsSubTotalPp,
        'memberAdults': value.memberAdults,
        'memberChldDetails': JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetailsToJSON(value.memberChldDetails),
        'couponApplicable': value.couponApplicable === undefined ? undefined : ((value.couponApplicable as Array<any>).map(JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicableToJSON)),
        'subsidyReservations': value.subsidyReservations === undefined ? undefined : ((value.subsidyReservations as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationToJSON)),
    };
}

